<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-non-bodymatter element-container-single element-type-dedication element-without-heading" id="dedication">
<div class="text" id="dedication-text">
<p class="first first-in-chapter first-full-width dedication-content">For all those who love Jane Austen and happy ever afters…</p>
<p class="subsq dedication-content">And for my mother who wanted to know what happened next…</p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?160d354a